import React from 'react';
// import {useHistory} from 'react-router-dom';
// import {useSelector, useDispatch} from 'react-redux';

import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
}));

export default function Error(props) {
  const classes = useStyles();
  // const theme = useTheme();
  // const [open, setOpen] = React.useState(false);

  return <div className={classes.root}>{props.error.message}</div>;
}
